module.exports = "<div class=\"picker-result author\"> <strong class=title title=\"{{ resource.title }}\">{{ resource.title }}</strong> </div> ";